// RevoltModal Component
// Displays modal dialogs with customizable content

import React from 'react';
import { createPortal } from 'react-dom';
import './RevoltModal.css';

export function RevoltModal({
  isOpen,
  onClose,
  title,
  children,
  showCloseButton = true,
  containerClassName = '',
  closeOnBackdrop = true,
  headerRightElement,
}) {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (closeOnBackdrop && e.target === e.currentTarget) {
      onClose();
    }
  };

  const modalContent = (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className={`modal-container ${containerClassName}`.trim()} onClick={(e) => e.stopPropagation()}>
        <div className={`modal-header ${headerRightElement ? 'has-right-element' : ''}`}>
          <div className="modal-header-left">
            {title && <h2 className="modal-title">{title}</h2>}
          </div>
          <div className="modal-header-right">
            {headerRightElement}
            {showCloseButton && (
              <button className="modal-close" onClick={onClose} aria-label="Close">
                <i className="fa-solid fa-times"></i>
              </button>
            )}
          </div>
        </div>
        <div className="modal-content">
          {children}
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
}

